import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import API from "../Network/API";
import { useDispatch, useSelector } from "react-redux";
import Agent from "../Network/Agent";
import { useEffect } from "react";
import { USER_FETCH_START } from "../Reducer/profileSlice";
import DashboardSettingModel from "../Models/DashboardSettingModel";
import { RMS_STATION_FETCH_START } from "../Reducer/RmsStationSlice";

export default function Nav() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [data_menu, setDataMenu] = useState([]);
  const [active_menu, setActiveMenu] = useState(false);

  const selector = useSelector((state) => state.siteIdReducer)
  const selector_batteryId = useSelector((state) => state.batteryIDReducer)
  const selector_acmId = useSelector((state) => state.acmIDReducer)
  const selector_recId = useSelector((state) => state.rectifierIDReducer)
  const selector_offlineID = useSelector((state) => state.offlineIDReducer)
  const [modalDialog, setModalDialog] = useState(false);
  const rmsAlarmID = useSelector((state) => state.rmsAlarmIdReducer)

  const toggleModal = () => {
    setModalDialog(!modalDialog)
}

  const ToggleSwitch = () => (
    setActiveMenu(!active_menu)
  )


  if (active_menu) {
    document.body.classList.add(
      'offcanvas-active'
    );
  } else {
    if (document.body.classList.contains('offcanvas-active')) {
      document.body.classList.remove('offcanvas-active');
    }
  }

  const _logout = () => {
    API.get(`/v1/oauth/logout`)
      .then(res => {
        if (res.data.success === true) {
          localStorage.clear();
        }
      })
    localStorage.clear();
    window.location.href = '/';
  }

  const _get_menu = () => {
    API.get(`/v1/oauth/get_menu`)
      .then(res => {
        setDataMenu(res.data.data.menus)
      })

  }


  const _profile = () => {
    API.get(`/v1/oauth/my_profile`)
      .then(res => {
        dispatch(USER_FETCH_START(res.data.data))
      })

  }

  useEffect(() => {
    _get_menu()
    _profile()
    dispatch(RMS_STATION_FETCH_START());
    Agent.Notification.latest(dispatch);
    Agent.All_RMS.all(dispatch);
    Agent.RMS_ALARM.nav(dispatch);

  }, []);

  const handleNotificationView = () => {
    Agent.Notification.readAll();
    Agent.Notification.latest(dispatch);
  }
  const navigate = useNavigate();
  const notificationData = useSelector((state) => state.notifyReducer?.data)

  return (
    <>
      <nav className="navbar navbar-expand-lg p-0 navbar-custom" id="page_top">
        <div className="container-fluid">
          <div className="page-header w-100">
            <div className="left">
              { location.pathname == `/rms_alarm_filter/${rmsAlarmID?.data}/fatch` || location.pathname=='/roles' || location.pathname=='/users' ||  location.pathname=='/acm-monitoring' || location.pathname=='/login-information' || location.pathname=='/password-change' || location.pathname == '/notification_setting' || location.pathname == '/organisation_users' || location.pathname == '/reports' || location.pathname == '/access_permission' || location.pathname == '/organisations' || location.pathname == '/all_doors' || location.pathname == '/all_jobs' || location.pathname == '/rms_stations' || location.pathname == '/rectifier_monitoring' || location.pathname == '/timeline' || location.pathname == '/alarms' || location.pathname == '/rms_alarms' || location.pathname == '/all_sites' || location.pathname == '/offline_sites' || location.pathname == '/offline_sites/' + selector_offlineID.data || location.pathname == '/online_sites' || location.pathname == '/dc_energy' ? <Link onClick={() => navigate(-1)}><i className="fa-duotone fa-arrow-left me-1"></i></Link> : location.pathname == '/' ? <i className="fa-light fa-grid-2 me-1"></i> :
                <a href="#" className="nav-link icon menu_toggle" onClick={() => ToggleSwitch()}><i className="fa-light fa-align-left" /></a>
              }
              <div className="page-title">
                {location.pathname == `/rms_alarm_filter/${rmsAlarmID?.data}/fatch` ?'Active Alarm':location.pathname=='/roles'? 'Roles' :location.pathname=='/users'? 'User Management' :location.pathname=='/acm-monitoring'?'AC Energy Meter':location.pathname=='/login-information'?'Login Information':location.pathname=='/password-change'?'Change Password' : location.pathname == '/notification_setting'?'Notification Settings':location.pathname == '/reports'?'Report': location.pathname == '/access_permission'?'Access Permission' :location.pathname == '/organisation_users' ? 'Vendor Users' : location.pathname == '/organisations' ? 'Organisations' : location.pathname == '/all_doors' ? 'All Doors' : location.pathname == '/all_jobs' ? 'Job Management' : location.pathname == '/rms_stations' ? 'RMS Stations' : location.pathname == '/rectifier_monitoring' ? 'Rectifier monitoring' : location.pathname == '/offline_sites' || location.pathname == '/offline_sites/' + selector_offlineID.data ? 'Offline Sites' : location.pathname == '/online_sites' ? 'Online Sites' : location.pathname == '/all_sites' ? 'All Sites' : location.pathname == '/dc_energy' ? 'DC Energy Meter' : location.pathname === '/' ? 'Dashboard' : location.pathname === '/timeline' ? 'Timeline' : location.pathname === '/alarms' ? 'ACS Alarm Histroy' : location.pathname === '/rms_alarms' ? 'RMS Alarm Histroy' : location.pathname === '/site/' + selector?.data + '/alarms' ? <span>Alarms History (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/bms' ? <span>Battery (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/bms/' + selector_batteryId?.data + '/dashboard' || location.pathname === '/site/' + selector?.data + '/bms/' + selector_batteryId?.data + '/cell_monitoring' || location.pathname === '/site/' + selector?.data + '/bms/' + selector_batteryId?.data + '/graph' ? <span><Link to={'/site/' + selector?.data + '/bms'} ><i className="fa-duotone fa-arrow-left me-2" /></Link>Battery (<span className="font-11">SL NO:{selector_batteryId?.data}</span>) (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/alarms/rms' ? <span>Alarm History (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data ? <span>Site Overview (<span className="font-11">Site ID:{selector?.data}</span>)</span> : location.pathname === '/site/' + selector?.data + '/dc_energy_meter' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/graph' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/dc_consumption' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/dc_tenant' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/load_disconnect' || location.pathname === '/site/' + selector?.data + '/dc_energy_meter/overload' ? <span>DC Energy Meter (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/pg' ? <span>PG/DG Monitoring (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/ac_energy_meter/' + selector_acmId.data || location.pathname === '/site/' + selector?.data + '/ac_energy_meter/' + selector_acmId.data + '/graph' || location.pathname === '/site/' + selector?.data + '/ac_energy_meter/' + selector_acmId.data + '/report' ? <span>AC Energy Meter (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/assets' ? <span>Site Assets (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span> : location.pathname === '/site/' + selector?.data + '/rectifier/' + selector_recId.data || location.pathname === '/site/' + selector?.data + '/rectifier/' + selector_recId.data + '/report' || location.pathname === '/site/' + selector?.data + '/rectifier/' + selector_recId.data + '/graph' ? <span>Rectifier Monitoring (<Link to={`/site/${selector?.data}`} className="font-11">Site ID:{selector?.data}</Link>)</span>:location.pathname === '/site/' + selector?.data + '/temperature' ? <span>Temperature (<span className="font-11">Site ID:{selector?.data}</span>)</span> : ''}
              </div>
            </div>
            <div className="right">
              <div className="navbar-collapse" id="main_nav">
                <ul className="navbar-nav tree-menu">


                  <li className="nav-item dropdown" id="myDropdown">
                    <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                      <i className="fa-regular fa-bars me-1" /> Menu

                    </a>
                    <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">

                      {data_menu.length > 0 && data_menu?.map((row, index) => (
                        <>
                          {row.submenus?.length <= 0 ?
                            <li key={index}>
                              <Link className="dropdown-item" to={row.path}>
                                {row.title}
                              </Link>
                            </li>
                            :
                            <li> <a className="dropdown-item" href="#"> {row.title} » </a>
                              <ul className="submenu dropdown-menu dropdown-menu-start">
                                {row?.submenus?.map((srow, k) => (
                                <li key={k}><Link className="dropdown-item" to={srow.path}>{srow.title}</Link></li>
                                ))}
                              </ul>
                            </li>

                          }
                        </>

                      ))}
                      

                    </ul>
                  </li>
                </ul>
                <div className="notification d-flex">
                  <div className="dropdown d-flex">
                    <a className="nav-link icon d-md-flex btn btn-default btn-icon  dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <i className="fa-duotone fa-bell" />
                      <span className="badge bg-danger nav-unread">{notificationData?.total_count}</span>

                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                      <ul className="list-unstyled feeds_widget">
                        {notificationData.notification?.map((value, index) => (
                          <li key={index} className={` ${value.read_at == null ? "notification-unseen-color" : ""}`}>
                            <div className="feeds-left"><i className="fal fa-bell" /></div>
                            <div className="feeds-body">
                              <h4 className="title">{value.title}<small className="float-end text-muted fs-11">{value.alarm_start}</small></h4>
                              <small>{value.body}</small>
                            </div>
                          </li>
                        ))}
                      </ul>
                      <div className="dropdown-divider" />
                      <a href="javascript:void(0)" onClick={() => handleNotificationView()} className="dropdown-item text-center text-muted-dark readall">Mark all as read</a>
                      <a href="javascript:void(0)" className="dropdown-item text-center text-muted-dark readall">See all</a>
                    </div>
                  </div>
                  <div className="dropdown d-flex">
                    <a className="nav-link icon d-md-flex btn btn-default btn-icon dropdown-toggle p-0 ms-2 user-setting" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <img className="avatar" src="/assets/image/avatar.png" alt="" />
                    </a>
                    <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                      <a className="dropdown-item" href="#" onClick={()=>toggleModal(true)}><i className="dropdown-icon fal fa-cog" /> Profile</a>
                      <Link className="dropdown-item" to={`notification_setting`}><i className="dropdown-icon fal fa-cog" /> Notification Settings</Link>
                      <div className="dropdown-divider" />
                      <Link className="dropdown-item" to={`password-change`}><i className="dropdown-icon fal fa-question-circle" /> Password change?</Link>
                      <a className="dropdown-item" href="#" onClick={() => _logout()}><i className="dropdown-icon fal fa-power-off" /> Sign out</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <DashboardSettingModel isModalVisible={modalDialog} handleShowB={() => setModalDialog(false)}/>
    </>
  )
}